import React from 'react';

const education = [
  {
    degree: "Master's in Computer Applications (AI/ML)",
    school: 'Chandigarh University',
    detail: 'Specialization in Artificial Intelligence & Machine Learning',
    period: '2026 — 2028',
    status: 'Pursuing',
  },
  {
    degree: "Bachelor's in Computer Application",
    school: 'Rajiv Academy for Technology & Management',
    detail: 'Dr. B.R. Ambedkar University',
    period: '2023 — 2026',
    status: 'Completed',
  },
];

const experience = [
  {
    role: 'Software Engineering Intern',
    company: 'InTalksAI (INTALKSAI PRIVATE LIMITED)',
    period: 'Aug 2026 — Present',
    highlights: [
      'Building AI-powered software for virtual contact centers',
      'Working on software development, AI/ML solutions, and testing',
      'Reporting to the CTO on assigned engineering work',
    ],
  },
  {
    role: 'Open Source Contributor',
    company: 'Various Projects',
    period: '2022',
    highlights: [
      'Contributed to multiple open-source projects',
      'Active member of developer communities',
      'Mentored junior developers',
    ],
  },
  {
    role: 'Freelance Developer',
    company: 'Self-Employed',
    period: '2021',
    highlights: [
      'Developed 25+ web applications for diverse clients',
      'Specialized in React ecosystem and modern web technologies',
      'Delivered solutions that improved client engagement by 40%',
    ],
  },
];

const Resume = () => {
  return (
    <section id="resume" className="section border-b border-[var(--line)]">
      <div className="wrap">
        <p className="t-kicker mb-4">Resume</p>
        <h2 className="t-display text-5xl md:text-6xl mb-14">
          Path so far.
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <p className="t-kicker mb-6">Education</p>
            <div className="relative pl-6 border-l border-[var(--line)]">
              {education.map((item) => (
                <div key={item.degree} className="relative pb-10 last:pb-0">
                  <span className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full bg-[var(--signal)]" />
                  <p className="text-xs text-[var(--signal)] mb-2">{item.status} · {item.period}</p>
                  <p className="text-xl text-[var(--ink)] mb-1">{item.degree}</p>
                  <p className="t-muted">{item.school}</p>
                  <p className="t-muted">{item.detail}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <p className="t-kicker mb-6">Experience</p>
            <div className="relative pl-6 border-l border-[var(--line)]">
              {experience.map((item) => (
                <div key={item.role} className="relative pb-10 last:pb-0">
                  <span className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full bg-[var(--ink)]" />
                  <p className="text-xs text-[var(--muted)] mb-2">{item.period}</p>
                  <p className="text-xl text-[var(--ink)] mb-1">{item.role}</p>
                  <p className="t-muted mb-4">{item.company}</p>
                  <ul className="space-y-2">
                    {item.highlights.map((line) => (
                      <li key={line} className="t-body">{line}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
